module.exports = __webpack_public_path__ + "img/text-share.a76831e7.png";